// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"e9d46a8f","551":"3f6e3e9a","757":"644f9396","828":"89358f49"}[chunkId] + ".chunk.js";
};